import { AnyAction } from 'redux';
import { FormikErrors } from 'formik';

import { CUSTOMER_CONDITIONS_RECEIVED, CUSTOMER_CONDITIONS_UPDATE } from './customer-conditions-actions';
import { CUSTOMER_DETAIL_RESET } from '../../store/customer-detail-actions';
import { CustomerConditions } from '../models/customer-conditions';
import { CustomerConditionsFormValues } from '../models/customer-conditions-form-values';

export interface CustomerConditionsReducerState {
    conditions: CustomerConditions | null;
    isValid: boolean;
    isDirty: boolean;
    errors: FormikErrors<CustomerConditionsFormValues>;
    /**
     * The conditions as the server last handed them over (#2159). `conditions`
     * cannot serve: leaving the tab parks its input right there.
     */
    baseline?: CustomerConditions;
}

export const initialCustomerConditionsReducerState: CustomerConditionsReducerState = {
    conditions: null,
    isValid: true,
    isDirty: false,
    errors: {},
};

export const customerConditionsReducer = (
    state: CustomerConditionsReducerState = initialCustomerConditionsReducerState,
    action: AnyAction
): CustomerConditionsReducerState => {
    switch (action.type) {
        case CUSTOMER_DETAIL_RESET: {
            return initialCustomerConditionsReducerState;
        }

        case CUSTOMER_CONDITIONS_UPDATE: {
            const { formData, isDirty, isValid, errors } = action;

            const nextConditions = {
                ...state.conditions,
                ...formData,
            };

            return {
                ...state,
                conditions: nextConditions,
                isDirty: state.isDirty || isDirty,
                isValid,
                errors,
            };
        }

        case CUSTOMER_CONDITIONS_RECEIVED: {
            const received = {
                ...action['conditions'],
                discount: action['conditions'].discount,
            };

            return {
                ...state,
                conditions: received,
                // The same values, kept apart from the ones the tab edits.
                baseline: received,
            };
        }

        default: {
            return state;
        }
    }
};
